import { ProcessActions } from '../../reflux/process_store';
import { ProcessAPI } from 'lecom-api';

export default class CancelProcessResponseHandler {
	static execute(storeItem, response, request) {
		//TODO: Usar a ProcessAPI para executar a ação
		const messages = CancelProcessResponseHandler.buildFormReturnMessages();
		ProcessActions.displayFormResultMessages(storeItem.id, messages);
	}

	static buildFormReturnMessages() {
		const messages = [];
		messages.push(CancelProcessResponseHandler.buildMessageObject(Realize.i18n.t('activity.messages.activityCancelled')));
		messages.push(CancelProcessResponseHandler.parseProcessCancelledMessage());

		return [
			{
				activityInstanceData: null,
				messages: messages
			}
		];
	}

	static parseProcessCancelledMessage() {
		let message = "";
		message += `${Realize.i18n.t('process.messages.processFinished')}. Status: `;
		message += Realize.i18n.t(`process.status.REJECTED`);

		return CancelProcessResponseHandler.buildMessageObject(message);
	}

	static buildMessageObject(message, htmlSafe=false) {
		return { message, htmlSafe };
	}
}
